import { intervalToDuration } from 'date-fns';

const formatTimeUnit = (count: number, unit: string) => {
  return `${count} ${unit}${count > 1 ? 's' : ''} ago`;
};

export const formatPostTimeToDisplayValue = (time: string) => {
  // Convert the time string to a Date object to ensure proper timezone handling
  const startDate = new Date(time);
  const endDate = new Date();

  // If the start date is in the future (due to timezone/clock differences),
  // return "Just now" to prevent negative time displays
  if (startDate > endDate) {
    return 'Just now';
  }

  const interval = intervalToDuration({ start: startDate, end: endDate });

  let formattedTime = 'Just now';
  if (interval.years) {
    formattedTime = formatTimeUnit(interval.years, 'year');
  } else if (interval.months) {
    formattedTime = formatTimeUnit(interval.months, 'month');
  } else if (interval.days) {
    const weeks = Math.floor(interval.days / 7);
    if (weeks > 0) {
      formattedTime = formatTimeUnit(weeks, 'week');
    } else {
      formattedTime = formatTimeUnit(interval.days, 'day');
    }
  } else if (interval.hours) {
    formattedTime = formatTimeUnit(interval.hours, 'hour');
  } else if (interval.minutes) {
    formattedTime = formatTimeUnit(interval.minutes, 'minute');
  }

  return formattedTime;
};
